import { render } from "./announcements.vue?vue&type=template&id=0a20f8ae&scoped=true"
import script from "./announcements.vue?vue&type=script&lang=js"
export * from "./announcements.vue?vue&type=script&lang=js"

import "./announcements.vue?vue&type=style&index=0&id=0a20f8ae&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a20f8ae"]])

export default __exports__